var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"400"}},[_c('v-card-text',{staticClass:"text-center"},[_vm._v(" The landingpage is not available. Contact the owner ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }